import React from "react";
import dayjs from "dayjs";

export const money = (n) =>
  n === null || n === undefined
    ? "-"
    : Number(n).toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const litres = (n) =>
  n === null || n === undefined ? "-" : Number(n).toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const whole = (n) => (n === null || n === undefined ? "-" : Number(n).toLocaleString("en-KE"));
export const formatDate = (v) => (v ? dayjs(v).format("DD MMM YYYY") : "-");
export const formatDateTime = (v) => (v ? dayjs(v).format("DD MMM YYYY HH:mm") : "-");

// Km covered since the vehicle's previous fill - only when both readings are
// known and the odometer actually moved forward.
export const kmSincePrevious = (t) => {
  if (t?.odometerReading == null || t?.previousOdometerReading == null) return null;
  const km = Number(t.odometerReading) - Number(t.previousOdometerReading);
  return km > 0 ? km : null;
};

// Wording stays NEUTRAL everywhere in this module: "Requires review",
// "Warning", "Fuel exception". An exception is a prompt for someone to look,
// never an accusation.
export const FUEL_TXN_STATUS_CLASS = {
  RECORDED: "badge-linesuccess",
  REQUIRES_REVIEW: "badge-linewarning",
  REVIEWED: "badge-lineinfo",
  VOIDED: "badge-linedanger",
};
export const FUEL_TXN_STATUS_LABEL = {
  RECORDED: "Recorded",
  REQUIRES_REVIEW: "Requires review",
  REVIEWED: "Reviewed",
  VOIDED: "Voided",
};
export const FUEL_TXN_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "RECORDED", label: "Recorded" },
  { value: "REQUIRES_REVIEW", label: "Requires review" },
  { value: "REVIEWED", label: "Reviewed" },
  { value: "VOIDED", label: "Voided" },
];

export const FUEL_REFILL_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "SUBMITTED", label: "Submitted" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
];

export const FUEL_SEVERITY = {
  REVIEW: { label: "Requires review", style: { background: "#FFF4E0", color: "#9A5B00", border: "1px solid #F0B95B" } },
  WARNING: { label: "Warning", style: { background: "#EEF0F3", color: "#475467", border: "1px solid #D0D5DD" } },
};

// Plain-English name for each exception code, shown beside the server's own message.
export const FUEL_EXCEPTION_LABEL = {
  CARD_VEHICLE_MISMATCH: "Mismatched card",
  ODOMETER_ROLLBACK: "Odometer lower than previous reading",
  ODOMETER_NO_MOVEMENT: "Odometer unchanged since previous fill",
  FUEL_TYPE_CARD_RESTRICTION: "Fuel type differs from the card's restriction",
  FUEL_TYPE_VEHICLE: "Fuel type differs from the vehicle's",
  LITRES_OVER_TANK: "Litres above tank capacity",
  LITRES_ABNORMAL: "Unusual litres",
  REPEAT_FILL: "Repeat fill",
  CARD_MONTHLY_AMOUNT_EXCEEDED: "Card monthly amount limit exceeded",
  CARD_MONTHLY_LITRES_EXCEEDED: "Card monthly litre limit exceeded",
  CARD_BALANCE_NEGATIVE: "Card balance below zero",
};

// One colour per kind of money movement (Batch200, 2026-10-02: "show the direct cash as
// seperate row and all in different colors"). Used by the Monthly Summary rows and the
// Refills list's payment badge so a colour means the same thing on every screen.
export const FUEL_ENTRY_COLORS = {
  OPENING: { text: "#4A148C", bg: "#F3E5F5", label: "Opening" },
  FUEL: { text: "#B71C1C", bg: "#FDECEA", label: "Fuel" },
  REFILL: { text: "#0D47A1", bg: "#E3F2FD", label: "Card refill" },
  CASH: { text: "#1B5E20", bg: "#E8F5E9", label: "Cash" },
};

// A refill is either loaded onto a CARD or handed over as CASH for one vehicle (Batch200).
export const PAYMENT_MODE_OPTIONS = [
  { value: "", label: "Card & Cash" },
  { value: "CARD", label: "Card" },
  { value: "CASH", label: "Cash" },
];
export const PaymentModeBadge = ({ mode }) => {
  const c = mode === "CASH" ? FUEL_ENTRY_COLORS.CASH : FUEL_ENTRY_COLORS.REFILL;
  return (
    <span className="badge" style={{ background: c.bg, color: c.text, border: `1px solid ${c.text}33`, fontWeight: 600 }}>
      {mode === "CASH" ? "Cash" : "Card"}
    </span>
  );
};
